import {
  TeamMemberRole,
  TeamMemberStatus,
  type TeamMemberWithUser,
} from "@fitness-app/data-models/entities/TeamMember";

// Only these roles host consultations on Calendly (prod, 2026-10): the list is who can have a calendar.
const HOST_ROLES: string[] = [TeamMemberRole.REGULAR_TRAINER, TeamMemberRole.SHARED_TRAINER];

type RosterMember = Pick<TeamMemberWithUser, "id" | "userId" | "role" | "status" | "assignedTrainers">;

/**
 * Who the trainer picker offers: active members who host consultations. A head coach gets only
 * themselves and the trainers they lead (`team_member_assigned`); the owner and administration get
 * everyone. RLS would let a head coach read every trainer's rows (`clients.read` ALL), so this is a
 * narrowing of the view, not of access.
 */
export const getCalendarTrainers = <Member extends RosterMember>(team: Member[], headCoachId: string | null) => {
  const hosts = team.filter(
    (member) => member.userId && member.status === TeamMemberStatus.ACTIVE && HOST_ROLES.includes(member.role),
  );

  if (!headCoachId) {
    return hosts;
  }

  const ledIds = new Set(
    team.find((member) => member.id === headCoachId)?.assignedTrainers?.map((assigned) => assigned.trainer?.id) ?? [],
  );

  return hosts.filter((member) => member.id === headCoachId || ledIds.has(member.id));
};
